import styled from "styled-components"
import { Link } from 'react-router-dom'


const Container = styled.div`
    flex: 1;
    margin: 3px;
    height: 70vh;
    position: relative;
    &:hover{
        background-color: #bff7bfcc;
        transform: scale(1.08);
        z-index: 1;
    }
`
const Image = styled.img`
    width: 100%;
    height: 100%;
    object-fit: cover;
`
const InfoContainer = styled.div`
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
`
const Title = styled.h2`
    color: #ffffff;
    margin-top: 75%;
    margin-bottom: 20px;
`

const Button = styled.button`
    font-weight: 500;
    border-style: none;
    padding: 10px 20px;
    background-color: whitesmoke;
    color: #6e6d6d;
    cursor: pointer;
    border-radius: 5px;
    &:hover{
        background-color: #bff7bfcc;
        transform: scale(1.07);
    }
`
const LinkStyle = {
    color: "black",
    textDecoration: "none"
}

const CategoryItem = ({ item }) => {
    return (
        <Container>
            <Image src={item.img} />
            <InfoContainer >
                <Title > {item.title} </Title>
                <Link style={LinkStyle} to="/service-item">
                    <Button>See more</Button>
                </Link>
            </InfoContainer>
        </Container>
    )
}

export default CategoryItem
